import React , {useState} from 'react';

import { Link } from 'react-router-dom';


function Policies(props) {
    const [dataPolicies] = useState([
        {
            id: 1,
            cate: '',
            title: 'About D.T Wallet',
            text : 'D.T Wallet is a digital voucher marketplace enabling users to purchase, store, manage, and redeem brand vouchers securely. We do not store money, provide wallet balance, allow withdrawals, or enable fund transfers.'
        },
        {
            id: 2,
            cate: 'none',
            title: 'Eligibility & Account Security',
            text : 'Users must be 18+ years old and are fully responsible for maintaining account security. Protect your login credentials and notify us immediately of any unauthorized access.'
        },
        {
            id: 3,
            cate: '',
            title: 'Data Collection & Privacy',
            text : 'We collect limited data including name, email, and transaction details solely for order processing and customer support. Your data is protected and never sold to third parties.'
        },
        {
            id: 4,
            cate: 'none',
            title: 'Voucher Delivery & Purchases',
            text : 'Vouchers are delivered digitally after successful payment confirmation. All purchases are final and non-refundable once the voucher is delivered to your account dashboard.'
        },
        {
            id: 5,
            cate: '',
            title: 'Refund Policy',
            text : 'Refunds apply only if payment is deducted but voucher is not delivered, or in case of duplicate transactions. Contact support within 7 days with transaction proof for resolution.'
        },
        {
            id: 6,
            cate: '',
            title: 'Voucher Usage & Expiry',
            text : 'Vouchers must be used according to respective brand terms and conditions. Expiry dates (if any) are defined by brands. Rewards or offers provided cannot be exchanged for cash.'
        },
        {
            id: 7,
            cate: 'none',
            title: 'Liability & Disclaimers',
            text : 'D.T Wallet is not responsible for misuse, third-party failures, or user errors. Our liability is limited to the voucher value. We are not affiliated with brands unless explicitly stated.'
        },
        {
            id: 8,
            cate: '',
            title: 'Payment Security & Legal',
            text : 'Payments are processed via secure third-party gateways. We do not store card details. Fraud or misuse may result in account suspension. All disputes are governed by Indian law.'
        },
    ])
    return (
        <div>

            <section className="tf-page-title">    
                <div className="tf-container">
                    <div className="row">
                        <div className="col-md-12">

                            <ul className="breadcrumbs">
                                <li><Link to="#">Pages</Link></li>
                                <li>Terms & Policies</li>
                            </ul>
                   
                        </div>
                    </div>
                </div>                    
            </section>
                
            <section className="tf-connect-wallet">
                <div className="tf-container">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div className="tf-heading style-5">
                                <h4 className="heading">Terms & Policies</h4>
                                <p className="sub-heading">Please read our terms of service and privacy policy carefully. By using D.T Wallet, you agree to these terms and conditions. </p>
                            </div>
                        </div>
                        {
                            dataPolicies.map(idx => (
                                <div key={idx.id} className="col-lg-4 col-md-6">
                                    <div className="tf-wallet">
                                        <div className="icon">
                                            <span className={`label ${idx.cate}`}></span>
                                        </div>
                                        <h6 className="title"><Link to="#">{idx.title}</Link></h6>
                                        <p className="content">{idx.text}</p>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>
            </section>
            
        </div>
    );
}

export default Policies;